import ArrowForwardIosRounded from '@material-ui/icons/ArrowForwardIosRounded';
import Facebook from '@material-ui/icons/Facebook';
import { Fragment, useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router';
import { useIsMobile } from '../../misc/mobile';
import routes from '../../misc/routes';
import AppLogo from '../AppLogo';
import './Navbar.scss';

const Navbar = () => {
  const [ opened, setOpened ] = useState(false);

  const { pathname } = useLocation();
  const isMobile = useIsMobile();

  const activeRoute = useMemo(() => {
    const matchingRoutes = Object.values(routes).filter(({ path }) => {
      return pathname.startsWith(path);
    });

    return matchingRoutes.reduce((a, b) => a.path.length > b.path.length ? a : b);
  }, [ pathname ]);

  const noPlaceholder = useMemo(() => {
    return (
      pathname === routes.home.path ||
      !!pathname.match(/\/news\/(?!(edit|upload)).+/g)
    );
  }, [ pathname ]);

  const departmentInfo = useMemo(() => {
    return Object.keys(routes.about.children).map((key) => {
      const k = key as keyof typeof routes.about.children;
      const p = routes.about.children[ k ].path;

      switch (k) {
        case 'atletika': return { path: p, name: 'Atlétika' };
        case 'kezilabda': return { path: p, name: 'Kézilabda' };
        case 'labdarugas': return { path: p, name: 'Labdarúgás' };
        case 'roplabda': return { path: p, name: 'Röplabda' };
        case 'tollaslabda': return { path: p, name: 'Tollaslabda' };
        case 'uszas': return { path: p, name: 'Báthory Vízi sportkör' };
        default: throw new Error('Invalid department key');
      }
    });
  }, []);

  useEffect(() => {
    document.title = activeRoute === routes.home || !activeRoute ? routes.home.title :
      `${ activeRoute.title } - ${ routes.home.title }`;
  }, [ activeRoute ]);

  useEffect(() => {
    if (opened) {
      window.document.body.style.overflowY = 'hidden';
    } else {
      window.document.body.style.overflowY = 'initial';
    }
  }, [ opened ]);

  return isMobile ? (
    <Fragment>
      <div className={ `app-navbar mobile${ opened ? ' opened' : '' } acrylic-translucent` }>
        <a href={ routes.home.path }>
          <h3>Báthory István DSE</h3>
        </a>
        <span onClick={ () => {
          setOpened(!opened);
        } }><ArrowForwardIosRounded color="inherit" /></span>
      </div>
      <div className={ `app-navbar-mobile-links${ opened ? ' opened acrylic-translucent' : '' }` }>
        { Object.values(routes).map(({ path, title, navbar }, i) => {
          return !navbar ? null : (
            <a href={ path } key={ i }
              className={ activeRoute?.path === path ? 'active' : undefined }>
              <h3>{ title }</h3>
            </a>
          );
        }) }
      </div>
      <div className={ `app-navbar-mobile-bg${ opened ? ' opened acrylic-translucent' : ''
        }` }></div>
      { noPlaceholder ? null : <div style={ { height: 120 } }></div> }
    </Fragment>
  ) : (
    <Fragment>
      <div className="app-navbar acrylic-translucent">
        <a href={ routes.home.path }>
          <AppLogo />
        </a>
        <div className="navbar-links">
          { Object.values(routes).map(({ path, title, navbar }, i) => {
            return !navbar ? null : (
              <a href={ path } key={ i }
                className={ activeRoute?.path === path ? 'active' : undefined }>
                <h3>{ title }</h3>
              </a>
            );
          }) }
        </div>
        <div className="navbar-department-links">
          { departmentInfo.map((d, i) => (
            <a href={ d.path } key={ i }>
              { d.name }
              <ArrowForwardIosRounded color="inherit" />
            </a>
          )) }
        </div>
        <a href="https://www.facebook.com/bathorydse"
          title="Facebook oldal"
          className="navbar-fb-button">
          <Facebook color="inherit" />
        </a>
      </div>
      { noPlaceholder ? null : <div style={ { height: 120 } }></div> }
    </Fragment>
  );
};

export default Navbar;
